var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "media-library-item" }, [
    _c(
      "div",
      {
        staticClass: "media-library-item-icon",
        on: {
          click: function($event) {
            return _vm.$emit("item-clicked")
          },
          dblclick: function($event) {
            return _vm.$emit("item-double-clicked")
          }
        }
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "media-library-item-name",
        on: {
          click: function($event) {
            _vm.isEditing = true
          }
        }
      },
      [
        !_vm.isEditing
          ? _c("span", [
              _vm._v(
                _vm._s(_vm._f("truncate")(_vm.displayName || _vm.name, 20))
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditing
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newName,
                  expression: "newName"
                }
              ],
              ref: "newNameInput",
              staticClass: "form-control",
              attrs: { type: "text", placeholder: _vm.nameEditorPlaceholder },
              domProps: { value: _vm.newName },
              on: {
                blur: function($event) {
                  _vm.isEditing = false
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.itemRenamed()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newName = $event.target.value
                }
              }
            })
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }